var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicalDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.408,
    height: 87.973,
    viewBox: "0 0 131.408 87.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(23564 -18243.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(-23564 18243.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1460,1418.526v-.054a4.489,4.489,0,0,0-2.547-3.631c-.461-.271-.732-.434-.894-.515-.054-.027-.081-.054-.108-.054l-.027-.027c-.027,0-.027,0-.027-.027h-.027a.026.026,0,0,0-.027-.027h-.027c-1.788-1.057-11.651-6.774-56.79-33a12.294,12.294,0,0,0-11.326,0l-9.239,5.338a.674.674,0,1,0,.677,1.165l9.239-5.337a10.9,10.9,0,0,1,9.971,0c.271.163,5.04,2.926,5.338,3.116-11.19,6.476-26.038,15.037-66.328,38.312h-.027l-6.015-3.495c-2.52-1.518-2.411-3.6.027-5.013l38.095-21.974a.674.674,0,1,0-.677-1.165l-38.095,21.973a4.4,4.4,0,0,0-2.547,3.685l.027,11.325a4.38,4.38,0,0,0,2.52,3.658c.271.163,17.259,10,18.316,10.621a.674.674,0,0,0,.678-1.165c-.271-.163-10.946-6.367-11.624-6.747,0-.271-.027-9.131-.027-9.727,5.88,3.414-10.919-6.34,50.559,29.371a12.3,12.3,0,0,0,11.325,0l57.034-32.92a7.136,7.136,0,0,0,1.219-.894l.027,8.507a3.162,3.162,0,0,1-1.9,2.52l-57.034,32.92a10.964,10.964,0,0,1-9.971,0l-31.944-18.56a.674.674,0,1,0-.678,1.165l31.945,18.56a12.54,12.54,0,0,0,11.325,0l57.034-32.92a4.433,4.433,0,0,0,2.574-3.685Zm-128.157,13.06a3.071,3.071,0,0,1-1.842-2.466l-.027-8.508a8.047,8.047,0,0,0,1.165.84l6.015,3.522.027,9.727Zm124.906-10.567-57.034,32.92a10.966,10.966,0,0,1-9.971,0c-40.1-23.274-44.354-25.767-50.531-29.371,1.057-.623,66.328-38.312,66.328-38.312,36.09,20.971,47.253,27.474,50.26,29.208,0,0,.027,0,.108.054.027.027.081.054.109.081.054.027.135.081.244.136.135.081.3.162.3.162a.026.026,0,0,0,.027.027l.027.027c.135.054.135.054.108.054a.084.084,0,0,0,.055.027C1459.482,1417.578,1459.075,1419.718,1456.745,1421.019Z",
    transform: "translate(-1328.615 -1379.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1352.691,1475.041c-1.377.8-1.386,2.085-.016,2.881a5.482,5.482,0,0,0,4.973,0c1.379-.8,1.384-2.085.016-2.88A5.477,5.477,0,0,0,1352.691,1475.041Z",
    transform: "translate(-1343.223 -1439.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1376,1461.582c-1.377.8-1.386,2.085-.016,2.881a5.481,5.481,0,0,0,4.972,0c1.378-.8,1.385-2.086.016-2.881A5.476,5.476,0,0,0,1376,1461.582Z",
    transform: "translate(-1358.004 -1431.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1399.315,1448.123c-1.377.8-1.386,2.085-.016,2.881a5.482,5.482,0,0,0,4.973,0c1.378-.8,1.385-2.086.016-2.881A5.476,5.476,0,0,0,1399.315,1448.123Z",
    transform: "translate(-1372.786 -1422.746)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(-23534.766 18259.32)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y1: 25.616,
    x2: 44.079,
    transform: "translate(37.922 22.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    y1: 5.985,
    x2: 10.299,
    transform: "translate(34.458 0.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    y1: 13.918,
    x2: 23.949,
    transform: "translate(0.678 12.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M1469.924,1457.866a.675.675,0,0,0-.922-.244l-9.591,5.582v-4.5l23.843-13.845v4.47l-6.475,3.766a.674.674,0,0,0,.677,1.165l6.367-3.712.19-.027h.027c.3,0,.65.027.975.027a18.163,18.163,0,0,0,8.969-2.194c2.52-1.436,3.9-3.441,3.9-5.582v-6.042a5.245,5.245,0,0,0-.325-1.815.671.671,0,0,0-.434-.379.56.56,0,0,0-.542.054l-8.156,4.742-5.636-.894,5.148-2.98a.631.631,0,0,0,.352-.569v-5.067c0-.519-.405-.575-.677-.7a19.242,19.242,0,0,0-11.7,2c-2.52,1.463-3.9,3.441-3.9,5.582v.434l-24.521,14.225-.162.027a19.059,19.059,0,0,0-10,2.14c-4.266,2.473-3.77,5.554-3.875,5.825v5.771a4.38,4.38,0,0,0,.352,1.842.681.681,0,0,0,1,.325l8.129-4.741,4.335.677-2.818,1.653a1.013,1.013,0,0,0-.569.894v6.015a1.165,1.165,0,0,0,.623.948,1.72,1.72,0,0,0,.731.162,19.182,19.182,0,0,0,10.188-2.113c2.493-1.463,3.875-3.441,3.875-5.581v-.38l10.377-6.042A.668.668,0,0,0,1469.924,1457.866Zm26.607-17.611v2.52c0,1.653-1.138,3.224-3.224,4.416a16.934,16.934,0,0,1-8.7,2v-4.687c.3-.031,5.294.2,9.375-2.168A10.621,10.621,0,0,0,1496.531,1440.255Zm-9.592-5.771-5.527,3.224-1.3-2.764,6.828-3.956Zm-51.832,26.607,7.017-4.064v4.443l-7.017,4.091Zm8.372.19v-4.633l2.845.433,3.333.515,1.571,3.333-2.113,1.246Zm8.969.514a.636.636,0,0,0,.325-.569.977.977,0,0,0-.054-.3l-1.978-4.254a.933.933,0,0,0-.217-.244,1,1,0,0,0-.3-.136l-7.234-1.111a1.418,1.418,0,0,0-.515.081c-.292,0-5.893,3.394-7.614,4.389a1.749,1.749,0,0,1-.054-.515v-.027c.1-.271-.351-2.382,3.2-4.389a17.467,17.467,0,0,1,9.348-1.978h.19l.325-.081a1.7,1.7,0,0,0,.217-.081l24.873-14.441a1.168,1.168,0,0,0,.433-.786c.078-.271-.733-2.769,3.2-5.067a16.7,16.7,0,0,1,8.779-1.978l-6.448,3.766a.7.7,0,0,0-.3.867l1.978,4.254a.749.749,0,0,0,.379.325.207.207,0,0,0,.135.054l7.343,1.11a.628.628,0,0,0,.433-.081l7.614-4.417a3.281,3.281,0,0,1,.027.515c0,1.975-1.492,3.468-3.224,4.47a17.391,17.391,0,0,1-9.348,1.951,2.312,2.312,0,0,0-.7.163c-2.535,1.476-18.654,10.852-24.873,14.468a1.148,1.148,0,0,0-.46.894v1.165c-.824,4.12-7.41,5.811-11.9,5.731C1446.3,1465.388,1452.718,1461.639,1452.448,1461.795Zm5.5,3.414c0,1.625-1.138,3.2-3.2,4.417a17.672,17.672,0,0,1-9.51,1.924v-4.661c3.791.271,10.644-1.055,12.735-4.2Z",
    transform: "translate(-1424.324 -1427.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1555.632,1483.818a.675.675,0,0,0-.926-.246l-44.079,25.615a.677.677,0,1,0,.68,1.172l44.079-25.615A.678.678,0,0,0,1555.632,1483.818Z",
    transform: "translate(-1473.045 -1461.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1501.5,1431.673a.674.674,0,0,0,.34-.091l10.3-5.985a.677.677,0,1,0-.68-1.172l-10.3,5.985a.677.677,0,0,0,.34,1.263Z",
    transform: "translate(-1467.041 -1424.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1433.722,1456.637a.674.674,0,0,0-.926-.246l-23.95,13.918a.677.677,0,0,0,.68,1.172l23.95-13.918A.677.677,0,0,0,1433.722,1456.637Z",
    transform: "translate(-1408.508 -1444.601)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalDataIcon);
export default __webpack_public_path__ + "static/media/technical-data-icon.7fd5e7e51b116b8f6b8c9304d11fd376.svg";
export { ForwardRef as ReactComponent };